

import React from "react";

export default function GraphicMat(props) {
  const currentSlide = props.currentSlide;
  if (!currentSlide.graphicMat) {
    return null;
  }
  return (
    <div
      id={"Graphic material"}
      style={{
        position: "fixed",
        left: props.isMobile? "18%":"65vw",
        top: props.isMobile? "90%":"90vh",
        zIndex: "20",
        opacity: currentSlide.graphicMat ? "1" : "0.0",
        width: "100vw",
        height: "100vh",
        WebkitTransition: "opacity 1s",
      }}
    >
      {currentSlide.graphicMat.split("\r\n\r\n").map((p, i) => (
        <p
          key={i}
          style={{
            color: "white",
            backgroundColor : "black",
            display: "inline-block",
            padding:"4px",
            fontSize: props.isMobile ? "15px" : "18px",
            margin: props.isMobile ? "2vw 2vw 2vw 2vw":"1vw 0vw 5vw 0vw",
          }}
        >
          {p}
      </p>
      ))}
    </div>
  );
}
